/**
 * Download Context Provider Component
 */

import { clearUIState } from '../../redux/actions/ui';
import { localStorageKeySeparator, localStoragePrefix } from '../../redux/helpers/localStorage';
import { simulateClick } from '../../utils/dom';
import { getOriginLocation } from '../../utils/router';

import * as nextTick from 'next-tick';
import * as React from 'react';
import { connect, DispatchProp } from 'react-redux';

import { DownloadContext } from './';
import { IDownloadContext, SetAgreementVisibilityHandler, SetFilePathHandler } from './types';

interface IOwnStateProps {
  filePathFromStore?: string;
  trackFromStore?: GQL.ITrackSearchResult;
}

type DownloadContextProviderProps = IOwnStateProps & Required<DispatchProp<any>>;

export const downloadAgreementLocalStorageKey =
  `${localStoragePrefix}${localStorageKeySeparator}download-modal-visibility`;

class DownloadContextProviderBase extends React.Component<DownloadContextProviderProps, IDownloadContext> {
  constructor(props) {
    super(props);

    this.state = {
      dispatch: this.props.dispatch,
      clear: this.clear,
      setFilePath: this.setFilePath,
      setAgreementVisibility: this.setAgreementVisibility,
      agreementVisibility: !!!window.localStorage.getItem(downloadAgreementLocalStorageKey),
    };
  }

  componentDidMount() {
    if (!!this.props.filePathFromStore) {
      this.setFilePathFromStore();
    }
  }

  componentDidUpdate(prevProps: DownloadContextProviderProps) {
    if (!!this.props.filePathFromStore && !!!prevProps.filePathFromStore) {
      this.setFilePathFromStore();
    }
  }

  clear = () => {
    this.setState({
      filePath: undefined,
      track: undefined,
    });
  }

  setFilePath: SetFilePathHandler = (filePath, track) => {
    this.setState({ filePath, track });
  }

  setFilePathFromStore() {
    setTimeout(() => {
      if (this.state.agreementVisibility === false) {
        this.autoDownloadTrack(this.props.filePathFromStore!);
      } else {
        this.setFilePath(this.props.filePathFromStore!, this.props.trackFromStore!);
      }
      this.props.dispatch(clearUIState('downloadAgreementModal'));
    }, 2000);
  }

  setAgreementVisibility: SetAgreementVisibilityHandler = (agreementVisibility) => {
    this.setState({ agreementVisibility }, () => {
      window.localStorage.setItem(downloadAgreementLocalStorageKey, `${agreementVisibility}`);
    });
  }

  render() {
    return (
      <DownloadContext.Provider value={this.state}>
        {this.props.children}
      </DownloadContext.Provider>
    );
  }

  autoDownloadTrack(path: string) {
    const downloadLink = document.createElement('a');
    downloadLink.setAttribute('class', 'download-link');
    downloadLink.setAttribute('href', `${getOriginLocation()}${path}`);
    document.body.appendChild(downloadLink);
    nextTick(() => {
      simulateClick(downloadLink);
      nextTick(() => {
        downloadLink.remove();
      });
    });
  }
}

export const DownloadContextProvider = connect<IOwnStateProps, DispatchProp<any>, {}, IStoreState>(
  ({ ui }) => ({
    filePathFromStore: ui.downloadAgreementModal && ui.downloadAgreementModal.filePath,
    trackFromStore: ui.downloadAgreementModal && ui.downloadAgreementModal.track,
  }),
  (dispatch) => ({ dispatch }),
)(DownloadContextProviderBase);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/contexts/download/provider.tsx